<template>
  <div>
    <page-header :on-return="() => $router.go(-1)" :page="page" />

    <board class="mb-4" :details="board" />

    <callout
      v-for="(result, idx) in itemsPaginated"
      :key="idx"
      :border-color="getStatusColor(result.admissionStatusId)"
      class="mb-3"
      :has-toggle="false"
    >
      <div class="row">
        <div class="col-sm-12 d-flex align-items-center col-md-2 border-right">
          <balloon
            :bg="
              `text-center font-14 border-none bg-${getStatusColor(
                result.admissionStatusId
              )}`
            "
            :text="result.admissionStatusName"
          />
        </div>
        <div class="col-sm">
          <div class="row">
            <div class="col-sm">
              <span class="data-label">Ocurrido:</span>
              <p class="data">{{ result.dateOfAction | date }}</p>
            </div>
            <div class="col-sm">
              <span class="data-label">Compañía:</span>
              <p class="data">{{ result.companyName }}</p>
            </div>
            <div class="col-sm">
              <span class="data-label">Centro:</span>
              <p class="data">{{ result.centeR_NAME }}</p>
            </div>
            <div class="col-sm">
              <span class="data-label">Cambiado por:</span>
              <p class="data">{{ result.actionUserName }}</p>
            </div>
          </div>
          <div class="row">
            <div v-if="result.admissionDate" class="col-sm-12 col-md-3">
              <span class="data-label">Fecha de Admisión:</span>
              <p class="data">{{ result.admissionDate | date }}</p>
            </div>
            <div v-if="result.specialist" class="col-sm">
              <span class="data-label">Especialista:</span>
              <p class="data">{{ result.specialist }}</p>
            </div>
          </div>
          <div class="row">
            <div
              v-if="
                result.admissionStatusId == statuses.NoVinculado &&
                  result.admissionStatusReasonId == rejectedByProvider
              "
              class="col-sm-12 col-md-12"
            >
              <span class="data-label">Razón del rechazo:</span>
              <p class="data">{{ result.referralDenyReason }}</p>
            </div>
          </div>
          <div class="row">
            <div
              v-if="
                result.admissionStatusId == statuses.NoVinculado &&
                  result.admissionStatusReasonId == rejectedByProvider
              "
              class="col-sm-12 col-md-12"
            >
              <span class="data-label">Comentario del rechazo:</span>
              <p class="data">{{ result.referralDenyComment }}</p>
            </div>
          </div>
        </div>
      </div>
    </callout>

    <pagination
      v-if="results.vwThrpyLastAdmissionHistory.length > paginationData.count"
      :data="pagination"
      @pagination-go-page="paginationData.currentPage = $event"
    />
  </div>
</template>

<script>
import { getReferralHistory as _getReferralHistory } from '@/modules/shared/studentreferral.api';
import Pagination from '@/components/common/Pagination';
import statusColorMixin from './common/statusColor';
import admissionStatuses from '@/utils/shared/constants/admissionStatus';

const Rechazado_por_Proveedor = 5;

export default {
  name: 'ReferralHistory',
  components: {
    Pagination,
  },
  mixins: [statusColorMixin],
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Manejo de Referidos',
        routes: ['Proveedor', 'Manejo de Referidos'],
      },
      results: {
        vwThrpyLastAdmissionHistory: [],
      },
      referralNumber: this.$route.params.referralNumber,
      admissionId: this.$route.params.admissionId,
      paginationData: {
        currentPage: 1,
        count: 10,
      },
      rejectedByProvider: Rechazado_por_Proveedor,
    };
  },
  computed: {
    pagination() {
      return {
        currentPage: this.paginationData.currentPage,
        count: this.paginationData.count,
        totalItemCount: this.results.vwThrpyLastAdmissionHistory.length,
        pageCount: Math.ceil(
          this.results.vwThrpyLastAdmissionHistory.length /
            this.paginationData.count
        ),
      };
    },
    statuses() {
      return admissionStatuses;
    },
    itemsPaginated() {
      let since = (this.pagination.currentPage - 1) * this.pagination.count;
      let until = since + this.pagination.count;
      return this.results.vwThrpyLastAdmissionHistory.slice(since, until);
    },
    board() {
      return [
        [
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: this.results.studentFullName,
          },
          {
            label: 'Fecha de Referido:',
            icon: 'fas fa-calendar-edit',
            data: this.$formatDate(this.results.referralDate),
          },
          {
            label: 'Modalidad:',
            icon: 'fas fa-ballot-check',
            data: this.results.serviceModalityTypeName,
          },
          {
            label: 'Frecuencia:',
            icon: 'fas fa-clock',
            data: this.results.frequencyTypeName,
          },
        ],
        [
          {
            label: 'Número de Referido:',
            icon: 'fas fa-address-book',
            data: this.referralNumber,
          },
          {
            label: 'Fecha Desde:',
            icon: 'fas fa-calendar-edit',
            data: this.$formatDate(this.results.effectiveDateFrom),
          },
          {
            label: 'Fecha Hasta:',
            icon: 'fas fa-calendar-edit',
            data: this.$formatDate(this.results.effectiveDateTo),
          },
          {
            label: 'Duración:',
            icon: 'fas fa-clock',
            data: this.results.durationTypeName,
          },
        ],
      ];
    },
  },
  mounted() {
    _getReferralHistory(this.admissionId).then(({ data }) => {
      this.results = data;
    });
  },
};
</script>
